import { config } from '@/config.ts';

type BrandFeaturesConfig = Record<string, string[]>;

/**
 * Map of available features for each brand
 * 
 * Available features:
 * - 'skinplace': Shows SkinplaceBanner on home page
 * - 'promo_group': Shows promo group block on home page
 * 
 * To add a new feature:
 * 1. Add feature name to the appropriate brand arrays
 * 2. Use isBrandFeatureAvailable('feature_name') in your component
 */
export const brandFeaturesMap: BrandFeaturesConfig = {
	default: ['skinplace', 'promo_group'],
	nomad: ['skinplace', 'promo_group'],
	rockets: ['promo_group'],
	rockets_vip: ['promo_group'],
	ngu3: [],
	com2: [],
	blitz: ['promo_group'],
	sk2: ['promo_group']
};

/**
 * Check if a feature is available for the current brand
 * @param feature - Feature name to check
 * @returns boolean - true if feature is available for current brand
 */
export const isBrandFeatureAvailable = (feature: string): boolean => {
	const brand = config.BRAND || 'default';
	const brandFeatures = brandFeaturesMap[brand] ?? brandFeaturesMap.default;
	
	return brandFeatures.includes(feature);
};

